<template>
  <div class="order_infos">
    <div class="imgs" v-for="(item, ind) in info.orderItems" v-if="ind <= 2">
      <img :src="item.imgUrl" alt />
      <div class="count">x{{ item.count }}</div>
    </div>
    <div class="order_data">
      <div>
        服务信息：{{ info.goodsTypeName }} |
        {{ info.serviceTypeName }}
      </div>
      <div>
        客户信息：{{ info.customerName }}
        {{ info.customerPhone }}
      </div>
      <div>客户地址：{{ setAddress(info.areaName, info.address) }}</div>
    </div>
    <div class="order_info_btn" @click="openOrderInfo(info)">
      订单详情 <i class="el-icon-arrow-right"></i>
    </div>
    <orderInfo-modal ref="orderInfoModal"></orderInfo-modal>
  </div>
</template>

<script>
export default {
  components: {
    orderInfoModal: () => import("../user/modules/orderInfoModal"),
  },
  props: {
    info: {
      type: Object,
      default: { orderItems: [] },
    },
  },
  data() {
    return {};
  },

  methods: {
    setAddress(splitAddress = "", address = "") {
      if (address.includes(splitAddress)) return address;
      else return splitAddress + address;
    },
    // 跳转订单详情
    openOrderInfo(item) {
      this.$refs.orderInfoModal.open(item);
    },
  },
};
</script>

<style lang='scss' scoped>
.order_infos {
  position: relative;
  height: 106px;
  background: #fff;
  margin-bottom: 10px;
  display: flex;
  padding: 16px 20px;
  .order_info_btn {
    position: absolute;
    right: 20px;
    top: 16px;
    color: #5e6066;
    font-size: 12px;
    line-height: 16px;
    cursor: pointer;
    &:hover {
      color: #3455d3;
    }
  }
  .order_data {
    margin-left: 14px;
    & > div {
      display: flex;
      color: #5e6066;
      font-size: 12px;
      line-height: 12px;
      margin-top: 14px;
      &:first-child {
        margin-top: 6px;
      }
    }
  }
  .goorderinfo {
    text-align: right;
    font-size: 12px;
    color: #5e6066;
    flex: auto;

    span:hover {
      cursor: pointer;
      color: #3455d3;
    }
    .iconbiaodan_rili_right {
      font-size: 12px;
      margin-top: 1px;
      display: inline-block;
    }
  }
  .imgs {
    position: relative;
    margin-right: 8px;
    img {
      width: 74px;
      height: 74px;
      &:last-child {
        margin-right: 0;
      }
    }
    .count {
      position: absolute;
      width: 100%;
      height: 24px;
      background: rgba(0, 0, 0, 0.5);
      font-size: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #ffffff;
      bottom: 0;
      left: 0;
    }
  }
}
</style>
